/**
 * Проверяет, загружено ли приложение внутри iframe
 * @returns {boolean} true если приложение в iframe, false если в обычном окне браузера
 */
export const isInIframe = () => {
  try {
    // Проверяем, отличается ли текущее окно от родительского
    // Если window.self !== window.top, значит мы внутри iframe
    return window.self !== window.top;
  } catch (e) {
    // Если произошла ошибка (например, cross-origin блокировка),
    // считаем что мы в iframe (безопасный fallback)
    return true;
  }
};
